import { GetQuestionsResponse_Answer, GetQuestionsResponse_Question } from "../api";

export interface QuestionAnswered {
    id: string,
    countPolicies: number,
    countCompanies?: number
}

export class Question {
    id: string;
    answers: Answer[];
    type: number;
    text: string;
    order: number;
    hint: string;
    index: string;
    dependentOn: string;
    isHidden: boolean = true;
    isScrollTo: boolean = false;
    isSuggested: boolean = false;
    prevQuestion: Question = undefined;
    nextQuestion: Question = undefined;

    static mapData(fQuestions: GetQuestionsResponse_Question[]): Question[] {
        let _questions: Question[] = [];
    
        if(fQuestions != null) {
            fQuestions = fQuestions.filter(q => q.Code != '1.0').sort((a, b) => {
                if(a.Order < b.Order) {
                  return -1
                }
                if(a.Order > b.Order) {
                  return 1
                }
          
                return 0
            });
            _questions = fQuestions.map((q, i) => {
                const newQ = new Question();
                newQ.id = q.Code;
                newQ.answers = Answer.mapData(q.Answers);
                newQ.type = q.Type;
                newQ.text = q.Text;
                newQ.order = q.Order;
                newQ.hint = q.Hint;
                newQ.index = q.Index;
                newQ.dependentOn = q.DependentOn;
                newQ.isHidden = true;
                newQ.isScrollTo = false;

                if(newQ.type == QuestionType.Range || newQ.type == QuestionType.SingleValue) {
                    newQ.answers = newQ.answers.reverse();
                }

                return newQ
            });
        }
    
        return _questions
      }
}
export type Questions = Question[];

export class Answer {
    id: string;
    type: number;
    text: string;
    order: number;
    value1: string;
    value2: string;
    isSelected: boolean = false;
    tagTxt: string;
    step: number;
    maxValue: number;
    minValue: number;
    default: boolean = false;

    static mapData(fAnswers: GetQuestionsResponse_Answer[]): Answer[] {
        let _answers: Answer[] = [];

        if(fAnswers != null) {
            _answers = fAnswers.map(a => {
                const newA = new Answer();
                newA.id = a.Code;
                newA.text = a.Text;
                newA.type = a.Type;
                newA.order = a.Order;
                newA.tagTxt = a.ShortText;
                newA.step = a.Step;
                newA.default = a.Default;

                return newA
            }).sort((a, b) => {
                if(a.order < b.order) {
                  return -1
                }
                if(a.order > b.order) {
                  return 1
                }
          
                return 0
            });
        }

        return _answers
    }
}
export type Answers = Answer[];

export enum QuestionType
{
    SingleAnswerRadio 	= 10,
    MultipleAnswerCheck = 11,
    Range 		        = 12,
    SingleValue 	    = 13,
    SingleAnswerCombo 	= 14,
    MultipleAnswerList 	= 15,
    RangeSlider         = 16,
    Slider              = 17
}

export enum AnswerType
{
    Default 	= 20,
    Number 	= 21,	// formato EN-us con separatore .
    Date 	= 22,	// formato iso 8601 con T per timezone, esempio "2021-07-15T11:31:03.5595275Z"
    String 	= 23	// formato UTF8
}